import React from 'react';

import { useTranslation } from '@crehana/i18n';

import type { CourseCardProps } from '../../types';

const Tag: React.FC<Partial<CourseCardProps>> = props => {
  const { isOrganization, courseTag, courseType } = props;
  const { t } = useTranslation();

  if (isOrganization) {
    return null;
  }

  if (courseType === 'free') {
    return (
      <div
        className="TagComponent flex items-center absolute z-2 py-4 px-8 rounded-5 bg-primary-lighter"
        css={`
          left: 12px;
          top: 12px;
        `}
      >
        <div className="font-caption text-white">{t('COURSE_TAG_FREE')}</div>
      </div>
    );
  }

  if (courseTag) {
    return (
      <div
        className="TagComponent flex items-center absolute z-2 py-4 px-8 rounded-5"
        css={`
          left: 12px;
          top: 12px;
          background-color: ${courseTag.backgroundColor || '#06f'};
        `}
      >
        {courseTag.icon && (
          <img
            src={courseTag.icon}
            alt={courseTag.textLabel as string}
            className="w-auto h-16 mr-4"
          />
        )}
        <div
          className="font-caption"
          style={{ color: courseTag.textColor || '' }}
        >
          {courseTag.textLabel}
        </div>
      </div>
    );
  }
  return null;
};

export default Tag;
